import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import Snippet from '@/shared/models/Snippet';

const SCHEMA = {
  ...BASE_SCHEMA,
  type: 'type',
  content: 'content',
  title: 'title',
  language: 'language',
  isDefaultLocked: 'isDefaultLocked',
};

export function parseSnippet(data: any): Snippet | null {
  return parseEntity(data, SCHEMA, Snippet);
}

export function parseSnippets(data: any): Array<Snippet> {
  return parseEntities(data, SCHEMA, Snippet);
}
